import { useRef } from 'react';
import { useAssistantWidget } from '../../contexts/assistant-widget-context';
import { useFi } from '../../contexts/fi-context';
import { FI_BLOB_GRADIENT, FI_BLOB_PATH, FI_GREY_DROP_SHADOW_CLASS, FI_ORANGE_DROP_SHADOW_CLASS } from './fi-styles';
import { cn } from '../../utils/cn';

export const FiBubble = () => {
  const { togglePanel, introVisible } = useFi();
  // Hide the bubble while either panel is open — each panel carries its own X.
  const { widgetOpen } = useAssistantWidget();
  const gradientIdRef = useRef(`fi-bubble-blob-${Math.random().toString(36).slice(2, 11)}`);
  const gradientId = gradientIdRef.current;
  const bubbleSizePx = 83;
  const svgSizePx = 85;

  const svgClassName = cn(
    'absolute left-1/2 top-1/2 -translate-x-1/2 -translate-y-1/2',
    'transform transition-transform duration-500 ease-in-out will-change-transform',
    introVisible ? '-rotate-[10deg]' : 'rotate-0',
  );

  if (widgetOpen) return null;

  return (
    <button
      type="button"
      aria-label="Open assistant"
      aria-expanded={false}
      onClick={togglePanel}
      style={{ width: bubbleSizePx, height: bubbleSizePx }}
      className={cn(
        'font-albert-sans fixed bottom-6 right-6 z-[60] flex shrink-0 origin-bottom-right items-center justify-center border-0 bg-transparent p-0 hover:scale-105 focus:outline-none focus-visible:ring-2 focus-visible:ring-orange-400 focus-visible:ring-offset-2',
        'transition-[width,height] duration-300 ease-in-out',
      )}
    >
      <span
        style={{ width: bubbleSizePx, height: bubbleSizePx }}
        className={cn(
          'relative flex origin-bottom-right items-center justify-center transition-[width,height] duration-300 ease-in-out',
          introVisible ? FI_ORANGE_DROP_SHADOW_CLASS : FI_GREY_DROP_SHADOW_CLASS,
        )}
      >
        <svg
          xmlns="http://www.w3.org/2000/svg"
          viewBox="0 0 83 83"
          fill="none"
          className={svgClassName}
          style={{
            width: svgSizePx,
            height: svgSizePx,
            transitionProperty: 'width,height',
            transitionDuration: '300ms',
          }}
          aria-hidden
        >
          <defs>
            <linearGradient
              id={gradientId}
              x1={FI_BLOB_GRADIENT.x1}
              y1={FI_BLOB_GRADIENT.y1}
              x2={FI_BLOB_GRADIENT.x2}
              y2={FI_BLOB_GRADIENT.y2}
              gradientUnits="userSpaceOnUse"
            >
              <stop stopColor="#FF815B" />
              <stop offset="1" stopColor="#FFB973" />
            </linearGradient>
          </defs>
          <path d={FI_BLOB_PATH} fill={`url(#${gradientId})`} />
        </svg>
        <span className="text-32px relative z-[1] pb-0.5 font-semibold leading-none tracking-wide text-white">fi</span>
      </span>
    </button>
  );
};
